module.exports = __webpack_public_path__ + "img/olc-screen-olc-3.d8252444.jpg";